const _ = require("lodash");

const OpsPage = require("./OpsPage");
const PageDataTriggers = require("./PageDataTriggers");

const {getIn, setIn} = require("../../../shared/ImmHelpers");

const {atPage, atUser} = require("./StateCursors");

// TODO: This once had both activity timing and page data saving both. But the
// activity stuff got ripped out, and basically everything that's left is
// within the user model. Maybe merge things in here with PageDataTriggers +
// OpsUser?

const savePageDataNow = function(user, api) {
	const m = user.model;
	const mostRecentPageData = getIn(m, ["mostRecentPageData"], null);
	const viewedPages = getIn(m, ["viewedPages"], null);
	const sequenceData = getIn(m, ["sequenceData"], null);
	const lastLevelNotified = getIn(m, ["lastLevelNotified"], null);
	const eventsTriggered = getIn(m, ["eventsTriggered"], {});
	api.savePageData(
		mostRecentPageData,
		viewedPages,
		sequenceData,
		lastLevelNotified,
		eventsTriggered
	);
};

const setupThrottlerInVault = function(vault) {
	const {api, throttler} = vault;

	throttler.config("pageData", {
		delay: 30000,
		run: user => savePageDataNow(user, api),
	});
};

const handleSaveSuccess = function(user, payload) {
	// Do nothing
	return user;
};

const handleSaveFail = function(user, payload, error, throttler) {
	throttler.queue("pageData", user);
	return user;
};

// The main page data function, intended to be used as a post-update hook.
const updatePageData = function(vault, oldState, newState, action) {
	const oldPage = atPage(oldState).get();
	const newPage = atPage(newState).get();
	const newUser = atUser(newState).get();
	if (
		!newPage ||
		!newPage.name ||
		!newUser ||
		!newUser.userID ||
		OpsPage.bypassOnDemoPages(newPage, newUser)
	) {
		return newState;
	}
	let hasPageDataUpdates = false;
	const placementTestInviteModalResult = PageDataTriggers.triggerPlacementTestInviteModal(
		vault,
		oldState,
		newState,
		hasPageDataUpdates
	);
	newState = placementTestInviteModalResult.newState;
	hasPageDataUpdates =
		hasPageDataUpdates || placementTestInviteModalResult.hasPageDataUpdates;

	// Check to see if notifications and tutorials should be shown
	// Don't show if the page is about to redirect away
	const willRefresh = newState.redirectURL;
	if (OpsPage.isSignedInStudentPage(newPage) && !willRefresh) {
		// Trigger notifications if not on an actively playing page
		if (
			!OpsPage.isActiveStudentPage(newPage) &&
			atUser(newState).getIn(["model", "xp"])
		) {
			const notif = PageDataTriggers.triggerStudentNotifications(
				vault,
				oldState,
				newState,
				hasPageDataUpdates
			);
			newState = notif.newState;
			hasPageDataUpdates = hasPageDataUpdates || notif.hasPageDataUpdates;
		}
		// Trigger tutorials
		const tut = PageDataTriggers.triggerTutorials(
			vault,
			oldState,
			newState,
			hasPageDataUpdates
		);
		newState = tut.newState;
		hasPageDataUpdates = hasPageDataUpdates || tut.hasPageDataUpdates;
	} else if (OpsPage.isInSchool(newPage)) {
		const wel = PageDataTriggers.triggerTeacherWelcome(
			vault,
			oldState,
			newState,
			hasPageDataUpdates
		);
		newState = wel.newState;
		hasPageDataUpdates = hasPageDataUpdates || wel.hasPageDataUpdates;
	} else if (
		// Trigger notifications that only show up on the report pages
		(OpsPage.isReportPage(newPage) || OpsPage.isParentPage(newPage)) &&
		!newState.redirectURL
	) {
		const notif = PageDataTriggers.triggerReportNotifications(
			vault,
			oldState,
			newState,
			hasPageDataUpdates
		);
		newState = notif.newState;
		hasPageDataUpdates = hasPageDataUpdates || notif.hasPageDataUpdates;
	}
	newState = atUser(newState).set(user => {
		if (!user || !user.model) {
			return user;
		}
		// Check if the user's mostRecentPageDataToSave has changed.
		const newPageData = OpsPage.getMostRecentPageData(newPage);
		if (
			newPageData &&
			OpsPage.isInTrainer(newPage) &&
			!_.isEqual(newPageData, user.model["mostRecentPageData"])
		) {
			user = setIn(user, ["model", "mostRecentPageData"], rpd => {
				const newChapter = _.get(newPageData, "chapterIndex");
				/**
				 * If we are at a page level that does not define a chapterIndex
				 * we set it based on two cases:
				 * 	case 1.1 If the new page and the old page are the same grade
				 * 			THEN: we use the chapterIndex of the old page
				 * 			WHY:  cases where we switch between trainer and library pages for example,
				 * 					when switching back to trainer, we want to remain in the same chapter
				 * 					defined by old page chapterIndex.
				 * 	case 1.2 If the grades are different
				 * 			THEN: we do not care to keep the chapterIndex but we want to set to a default value of zero(0)
				 * 														OR
				 * 	If chapterIndex is defined (case 2), we use the new page's data as is
				 */
				if (!_.isInteger(newChapter)) {
					if (newPageData.gradeNumber === rpd.gradeNumber) {
						// Case 1.1
						rpd = _.extend({}, newPageData, {
							chapterIndex: _.get(rpd, "chapterIndex"),
						});
					} else {
						// Case 1.2
						rpd = _.extend({}, newPageData, {chapterIndex: 0});
					}
				} else {
					// Case 2
					rpd = newPageData;
				}
				return rpd;
			});
			hasPageDataUpdates = true;
		}

		// Update pages viewed for tutorial
		if (oldPage && OpsPage.isTutorialPage(oldPage)) {
			const viewedPages = _.get(user, "model.viewedPages");
			if (viewedPages && viewedPages.indexOf(oldPage.name) < 0) {
				const newViewed = viewedPages.concat([oldPage.name]);
				user = setIn(user, ["model", "viewedPages"], newViewed);
				hasPageDataUpdates = true;
			}
		}
		return user;
	});
	if (hasPageDataUpdates) {
		vault.throttler.queue("pageData", atUser(newState).get());
	}
	return newState;
};

module.exports = {
	setupThrottlerInVault,
	handleSaveSuccess,
	handleSaveFail,
	updatePageData,
	savePageDataNow,
};
